import { render, staticRenderFns } from "./BuyProduct.vue?vue&type=template&id=69f1c126"
import script from "./BuyProduct.vue?vue&type=script&lang=js"
export * from "./BuyProduct.vue?vue&type=script&lang=js"
import style0 from "./BuyProduct.vue?vue&type=style&index=0&id=69f1c126&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports